import axios from 'axios'

export default {
  dialcastrecipientgroupList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/informacastdialcastrecipientgroup', { params: opts })
        .then(({ data }) => {
          context.commit('DIALCAST_RECIPIENT_GROUP_LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ===========================Socket Updates=====================
  dialcastrecipientgroupUpdated (context, opts) {
    const id = opts && opts.id ? opts.id : opts
    const populated = opts && opts.populate ? opts.populate : []
    const inList = context.state.list.find((i) => i.id === id)
    if (inList) {
      axios
        .get(`/api/informacastdialcastrecipientgroup/${id}`, { params: populated })
        .then(({ data }) => {
          if (data.id) {
            data.socketUpdate = true
            context.commit('DIALCAST_RECIPIENT_GROUP_LIST_UPDATE', data)
          }
        }).catch(() => {})
    }
  },
  dialcastrecipientgroupDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inList = context.state.list.find((i) => i.id === id)
    if (id === context.state.current.id) {
      context.commit('DIALCAST_RECIPIENT_GROUP_CURRENT', null)
    }
    if (inList) {
      context.commit('DIALCAST_RECIPIENT_GROUP_LIST_REMOVE', id)
    }
  }
}
